module.exports = __webpack_public_path__ + "img/Tech test Icon - white.a4224a39.svg";